// Dashboard Owner (owner 2026-10-11/12): pure display helpers (no imports, so Jest can test them).
// A value of null from the server means "no data yet" — shown as a note, never as 0.

const BULAN = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober",
  "November", "Desember"];
const BULAN_SINGKAT = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];

const bagian = (iso) => String(iso).slice(0, 10).split("-").map(Number);

// "2026-10" -> "Oktober 2026"
export function labelBulan(ym) {
  const [y, m] = bagian(`${ym}-01`);
  return `${BULAN[m - 1]} ${y}`;
}

// "2026-10-09" -> "9 Okt 2026"
export function tanggalPendek(iso) {
  if (!iso) return "—";
  const [y, m, d] = bagian(iso);
  return `${d} ${BULAN_SINGKAT[m - 1]} ${y}`;
}

// a week inside one month: "5–11 Okt"; a single day: "12 Okt"
export function labelMinggu(dari, sampai) {
  const [, m, d1] = bagian(dari);
  const [, , d2] = bagian(sampai);
  return d1 === d2 ? `${d1} ${BULAN_SINGKAT[m - 1]}` : `${d1}–${d2} ${BULAN_SINGKAT[m - 1]}`;
}

// the same days of last month: "1–12 Sep"
export function labelPeriode(p) {
  return p ? labelMinggu(p.dari, p.sampai) : "";
}

export function belumAdaData(dataPertama) {
  return dataPertama ? `belum ada data (aplikasi dipakai sejak ${tanggalPendek(dataPertama)})` : "belum ada data";
}

// comparison chip text: kini vs lalu (lalu null = no data before)
export function banding(kini, lalu) {
  if (lalu === null || lalu === undefined) return { teks: "belum ada data", arah: "netral" };
  if (kini === lalu) return { teks: "sama", arah: "netral" };
  if (!lalu) return { teks: "naik dari 0", arah: "naik" };
  const p = Math.round(((kini - lalu) / lalu) * 100);
  if (p === 0) return { teks: kini > lalu ? "naik <1%" : "turun <1%", arah: kini > lalu ? "naik" : "turun" };
  return { teks: `${p > 0 ? "+" : "−"}${Math.abs(p)}%`, arah: p > 0 ? "naik" : "turun" };
}

export function persen(bagianNilai, total) {
  if (!total || total <= 0) return 0;
  return Math.max(0, Math.min(100, Math.round((bagianNilai / total) * 100)));
}

// greeting by the shop's clock (hour 0–23)
export function salam(jamToko) {
  if (jamToko < 11) return "Selamat pagi";
  if (jamToko < 15) return "Selamat siang";
  if (jamToko < 18) return "Selamat sore";
  return "Selamat malam";
}

// "8 menit lalu" from two instants (ms)
export function lalu(isoWaktu, sekarangMs) {
  const detik = Math.max(0, Math.round((sekarangMs - new Date(isoWaktu).getTime()) / 1000));
  if (detik < 60) return "baru saja";
  const menit = Math.floor(detik / 60);
  if (menit < 60) return `${menit} menit lalu`;
  const jam = Math.floor(menit / 60);
  if (jam < 24) return `${jam} jam lalu`;
  return `${Math.floor(jam / 24)} hari lalu`;
}

export function inisial(nama) {
  const kata = String(nama || "").replace(/[^A-Za-z0-9 ]/g, " ").split(/\s+/).filter(Boolean);
  return (kata.length > 1 ? kata[0][0] + kata[1][0] : (kata[0] || "?").slice(0, 2)).toUpperCase();
}

// bars of the sales chart: newest first, width relative to the largest bar; the
// periods before the first data are merged into one "no data yet" row
export function batangOmzet(rows) {
  const maks = Math.max(0, ...rows.map((r) => r.omzet || 0));
  const out = [];
  for (const r of [...rows].reverse()) {
    const prev = out[out.length - 1];
    if (r.omzet === null && prev && prev.kosong) {
      prev.awal = r;
      continue;
    }
    out.push(r.omzet === null ? { ...r, kosong: true, awal: r, akhir: r, lebar: 0 } : { ...r, lebar: persen(r.omzet, maks) });
  }
  return out;
}

export function totalTindakan(list) {
  return (list || []).reduce((n, x) => n + (x.jumlah || 0), 0);
}

const HARI = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];

// the server's clock in the shop's zone ("2026-10-12T13:20:05+09:00") -> "Senin, 12 Oktober 2026 · 13.20"
export function judulWaktu(iso) {
  if (!iso) return "";
  const [y, m, d] = bagian(iso);
  const hari = HARI[new Date(Date.UTC(y, m - 1, d)).getUTCDay()];
  return `${hari}, ${d} ${BULAN[m - 1]} ${y} · ${String(iso).slice(11, 13)}.${String(iso).slice(14, 16)}`;
}

export function jamToko(iso) {
  return Number(String(iso || "").slice(11, 13)) || 0;
}
